<template>
  <div :class='$style.login'>
    <h1 :class='$style.title'>ログイン処理中</h1>
  </div>
</template>

<script>
export default {
  name: 'SsoPage',
  components: {},
  created: async function () {
    if (this.$route.query.uuid) {
      this.login()
    }
  },
  methods: {
    async login() {
      let uuid = this.$route.query.uuid

      await this.$axios
        .get('/api/' + this.$constants.API_VERSION + '/auth/saml', { params: { uuid: uuid } })
        .then((response) => {
          let auth_info = response.data.value

          this.$cookies.set('auth_info', {
            'tel_or_email': auth_info.tel_or_email,
            'access_token': auth_info.access_token,
            'expired_at': this.$dayjs().add(auth_info.expires_in, 's').format(),
            'refresh_token': auth_info.refresh_token
          })

          this.$store.commit('auth/setTelOrEmail', auth_info.tel_or_email)
          this.$store.commit('auth/setJuid', auth_info.juid)
          this.$store.commit('auth/setUserId', auth_info.user_id)

          this.$router.push('/home/home')
        })
        .catch(() => {
          // エラーハンドリング
          // 404ページに遷移
          this.$router.push('/404')
        })
    },
  }
}
</script>
<style lang='scss' module>
.login {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 68px 32px 47px 32px;
  box-sizing: border-box;
  text-align: left;

  @include mobile() {
    width: 375px;
    padding: 42px 32px 26px 32px;
  }
}

.title {
  margin-top: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  margin-bottom: 70px;

  @include mobile() {
    font-size: 24px;
    margin-bottom: 60px;
  }
}
</style>
